import CircularProgressBar from "Uitls/CircularProgressBar";
import { routes, showError } from "Uitls/Util";
import CustomModal from "components/customModal";
import MetaDataInformation from "components/modules/metadata/MetaDataInformation";
import React, { useEffect, useState, useRef, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import {
  fetchMetaDataDetails,
  fetchModuleDetails,
  cloneModule,
} from "services/apis";
import CopyWithName from "./CopyWithName";
import { useKeycloak } from "@react-keycloak/web";

export const CloneModule = ({ sourceModuleId, onClose }) => {
  const { t } = useTranslation();
  const [isloading, setIsloading] = useState(false);
  const [sourceModule, setSourceModule] = useState(undefined);
  const [metaDataDropDownList, setMetaDataDropDownList] = useState(undefined);
  const history = useHistory();
  const [showCopyWithName, setShowCopyWithName] = useState(false);
  const [cloneCompleted, setCloneCompleted] = useState(false);
  const [updatedMetadata, setUpdatedMetadata] = useState(null);

  useEffect(() => {
    getModuleDetails();
    // getDropDownDataForMetaDataScreen();
  }, []);

  useEffect(() => {
    if (sourceModule) {
      setIsloading(false);
    }
  }, [sourceModule]);

  const getModuleDetails = () => {
    setIsloading(true);
    fetchModuleDetails(sourceModuleId, (res, err) => {
      if (res && res?.data) {
        setSourceModule(res.data);
      } else {
        showError(err);
      }
    });
  };

  // const getDropDownDataForMetaDataScreen = () => {
  //   setIsloading(true);
  //   fetchMetaDataDetails((res, err) => {
  //     if (res) {
  //       try {
  //         setMetaDataDropDownList(res.data);
  //       } catch (e) {
  //         console.log(e);
  //       }
  //       return;
  //     }
  //     showError(err);
  //   });
  // };

  const goLastLocation = (sourceNew) => {
    const timestamp = Date.now();

    setTimeout(() => {
      const params = {
        pathname: routes.dashboard,
        state: {
          newlyClonedModules: sourceNew,
          timestamp: timestamp,
        },
      };
      history.push(params);
    }, 50);
  };

  const goToAssembleModulePage = (module) => {
    setShowCopyWithName(true);
    onClose();
  };

  const handleChildClose = () => {
    setShowCopyWithName(false);
    onClose();
  };

  const setOpenCopy = () => {
    setShowCopyWithName(true);
  };

  const { keycloak } = useKeycloak();
  const userName = !!keycloak.authenticated ? keycloak.tokenParsed.name : null;
  const makeCloneCopy = (updatedNames) => {
    const payload = {
      source: updatedMetadata?.source || sourceModule?.source || "",
      productDamId:
        updatedMetadata?.brand?.veevaId || sourceModule?.productDamId || "",
      productName:
        updatedMetadata?.brand?.displayName || sourceModule?.productName || "",
      countryDamId:
        updatedMetadata?.country?.veevaId || sourceModule?.countryDamId || "",
      countryName:
        updatedMetadata?.country?.displayName ||
        sourceModule?.countryName ||
        "",
      topicDamId:
        updatedMetadata?.topic?.veevaId || sourceModule?.topicDamId || "",
      topicName:
        updatedMetadata?.topic?.displayName || sourceModule?.topicName || "",
      subtopicDamId:
        updatedMetadata && "subtopic" in updatedMetadata
          ? updatedMetadata?.subtopic?.veevaId || ""
          : sourceModule?.subtopicDamId || "",
      subtopicName:
        updatedMetadata && "subtopic" in updatedMetadata
          ? updatedMetadata?.subtopic?.displayName || ""
          : sourceModule?.subtopicName || "",
      communicationObjectives:
        updatedMetadata?.communicationObjectives ||
        sourceModule?.communicationObjectives ||
        "",
      brandStyleGuidelines:
        updatedMetadata && "styleGuidelines" in updatedMetadata
          ? updatedMetadata?.styleGuidelines || ""
          : sourceModule?.brandStyleGuidelines || "",
      createdByName: userName,
      languageDamId:
        updatedMetadata?.language?.veevaId || sourceModule?.languageDamId || "",
      languageName:
        updatedMetadata?.language?.displayName ||
        sourceModule?.languageName ||
        "",
      therapeuticAreaDamId:
        updatedMetadata?.theraupaticArea?.veevaId ||
        sourceModule?.therapeuticAreaDamId ||
        "",
      therapeuticAreaName:
        updatedMetadata?.theraupaticArea?.displayName ||
        sourceModule?.therapeuticAreaName ||
        "",
      audienceDamId:
        updatedMetadata?.audience?.veevaId || sourceModule?.audienceDamId || "",
      audienceName:
        updatedMetadata?.audience?.displayName ||
        sourceModule?.audienceName ||
        "",

      strategicObjectives:
        updatedMetadata?.strategicobj?.map((obj) => ({
          strategicObjDamId: obj.veevaId,
          strategicObjName: obj.displayName,
        })) ||
        sourceModule?.strategicObjectives ||
        [],

      segments:
        updatedMetadata?.segment?.map((seg) => ({
          segmentDamId: seg.veevaId,
          segmentName: seg.displayName,
        })) ||
        sourceModule?.segments ||
        [],

      indications:
        updatedMetadata?.indication?.map((ind) => ({
          indicationDamId: ind.veevaId,
          indicationName: ind.displayName,
        })) ||
        sourceModule?.indications ||
        [],

      draftElementIncluded:
        updatedMetadata?.draftElementIncluded?.map((item) => ({
          draftElementIncludedName: item.displayName,
          draftElementIncludedDamId: item.veevaId,
        })) ||
        sourceModule?.moduleDraftElementIncluded?.map((item) => ({
          draftElementIncludedName:
            item.draftElementIncludedName || item.displayName,
          draftElementIncludedDamId:
            item.draftElementIncludedDamId || item.veevaId,
        })) ||
        [],
      creativeAgencyName:
        updatedMetadata && "agency" in updatedMetadata
          ? updatedMetadata?.agency?.displayName || ""
          : sourceModule?.creativeAgencyName || "",
      creativeAgencyDamId:
        updatedMetadata && "agency" in updatedMetadata
          ? updatedMetadata?.agency?.veevaId || ""
          : sourceModule?.creativeAgencyDamId || "",
      contentToneName:
        updatedMetadata && "contentTone" in updatedMetadata
          ? updatedMetadata?.contentTone?.displayName || ""
          : sourceModule?.contentToneName || "",
      contentToneDamId:
        updatedMetadata && "contentTone" in updatedMetadata
          ? updatedMetadata?.contentTone?.veevaId || ""
          : sourceModule?.contentToneDamId || "",
      sourceModuleId: sourceModule?.moduleId,
      sourceModuleNextUniqueModuleCode: sourceModule?.nextUniqueModuleCode,
    };
    const clonedModuleName = updatedNames?.source?.[0]?.moduleName;

    payload["moduleName"] = clonedModuleName;

    payload["sourceModuleDamName"] = sourceModule?.moduleDamName;

    const businessRules = [
      ...(updatedNames.mustExist || []).map((item) => ({
        moduleName: item.moduleName,
        sourceModuleId: item.sourceModuleId || item.id,
        sourceModuleNextUniqueModuleCode: item.sourceModuleNextUniqueModuleCode,
        sourceModuleDamName: item.sourceModuleDamName || item.moduleDamName,
        ruleCondition: "MustExistWith",
      })),
      ...(updatedNames.related || []).map((item) => ({
        moduleName: item.moduleName,
        sourceModuleId: item.sourceModuleId || item.id,
        sourceModuleNextUniqueModuleCode: item.sourceModuleNextUniqueModuleCode,
        sourceModuleDamName: item.sourceModuleDamName || item.moduleDamName,
        ruleCondition: "Optional",
      })),
    ];

    const appendeNamePayload = {
      ...payload,
      businessRules,
    };

    setTimeout(() => {
      cloneModule(sourceModule?.moduleId, appendeNamePayload, (res, err) => {
        if (res) {
          goLastLocation(res.data);
        } else {
          showError(err);
        }
        setIsloading(false);
        setCloneCompleted(true);
        setShowCopyWithName();
        onClose();
      });
    }, 1000);
  };

  return (
    <div>
      <CircularProgressBar isloading={isloading} />
      <CustomModal
        displayModal={sourceModule && !showCopyWithName && !cloneCompleted}
        hideModal={() => {
          onClose();
        }}
        size="lg"
        dilogClassName="alertModalSmall"
      >
        <MetaDataInformation
          closeMetaDataScreen={() => {
            onClose();
          }}
          gotoNextPage={goToAssembleModulePage}
          metaDataDropDownList={metaDataDropDownList || []}
          buttonLable={t("module.cloneModuleNext")}
          editMetaDataFlag={true}
          module={sourceModule}
          moduleType="cloned"
          setOpenCopy={setOpenCopy}
          setUpdatedMetadata={setUpdatedMetadata}
        />
      </CustomModal>
      {showCopyWithName && (
        <CopyWithName
          sourceModule={sourceModule}
          onClose={onClose}
          handleChildClose={handleChildClose}
          setCloneLoading={setIsloading}
          makeCloneCopy={makeCloneCopy}
        />
      )}
    </div>
  );
};
